import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { AuthProvider } from 'src/app/Services/auth-provider.service';
import { Router } from '@angular/router';

@Component({
   selector: 'embryo-HeaderCart',
   templateUrl: './HeaderCart.component.html',
   styleUrls: ['./HeaderCart.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderCartComponent implements OnInit, OnChanges {

   @Input() cartProducts : any;
   @Input() count        : any;
   @Input() currency     : string;

   mobWidth : any;
   mobScreenSize : number = 767;

   @Output() removeProductData : EventEmitter<any> = new EventEmitter();  

   hiddenBadge = true;

   constructor(
      private authService: AuthProvider,
      private router: Router
   ) {
      this.mobWidth = window.screen.width;
   }
   
   ngOnInit() {
   }

   ngOnChanges() {
      if(this.count && this.count != 0) {
         this.hiddenBadge = false;
      } else {
         this.hiddenBadge = true;
      }
   }

   public confirmationPopup(product:any) {
      this.removeProductData.emit(product);
   }

   public calculatePrice(product) {
      let total = null;
      total = product.price*product.quantity;
      return total;
   }
   public goToCart() {
     
      if(this.authService.isUserAuthenticated()){
         this.router.navigate(['/checkout/payment']);
      }else 
      {
         this.authService.setReturnUrl('/checkout/payment')
         this.router.navigate(['/checkout']);

      }
      
   }
}